import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="rounded-2xl overflow-hidden transition-all duration-300" style={{
    background: 'var(--cream)',
    border: '1px solid var(--cream-dark)'
  }} data-id="element-95">
      <button className="w-full px-8 py-6 flex items-center justify-between gap-4 text-left" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-96">
        <span className="font-bold text-lg" style={{
        color: 'var(--brown)',
        fontFamily: 'Playfair Display, serif'
      }} data-id="element-97">
          {question}
        </span>
        <ChevronDownIcon className="w-5 h-5 flex-shrink-0 transition-transform duration-300" style={{
        color: 'var(--gold-dark)',
        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
      }} aria-hidden="true" data-id="element-98" />
      </button>
      {isOpen && <div className="px-8 pb-6" data-id="element-99">
          <div className="h-px mb-4" style={{
        background: 'var(--cream-dark)'
      }} data-id="element-100" />
          <p className="leading-relaxed" style={{
        color: 'var(--brown-light)',
        lineHeight: '1.85'
      }} data-id="element-101">
            {answer}
          </p>
        </div>}
    </div>;
}
export function FAQSection() {
  return <section className="w-full py-20 px-6 pt-[30px] pb-[30px]" style={{
    background: 'var(--cream-dark)'
  }} aria-label="Preguntas frecuentes" data-id="element-102">
      <div className="max-w-3xl mx-auto" data-id="element-103">
        <div className="text-center mb-14" data-id="element-104">
          <p className="text-sm font-bold tracking-widest uppercase mb-4" style={{
          color: 'var(--gold-dark)'
        }} data-id="element-105">
            Resolvemos Tus Dudas
          </p>
          <h2 className="text-4xl md:text-5xl font-bold" style={{
          color: 'var(--brown)'
        }} data-id="element-106">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="flex flex-col gap-4" data-id="element-107">
          <FAQItem question="¿Y si no encuentro los ingredientes en mi país?" answer="Cada ingrediente fue seleccionado específicamente porque existe en los supermercados de México, Colombia, Argentina, Chile, Perú, Venezuela, Ecuador y Bolivia. El ebook incluye una guía completa de dónde comprar en cada país." data-id="element-108" />
          <FAQItem question="¿Y si no soy buena cocinera?" answer="El Método Repostería Zero funciona independientemente de tu nivel de experiencia. Hay recetas de nivel ⭐ que cualquier persona puede hacer la primera vez. El sistema te lleva de la mano desde lo más básico hasta lo más avanzado." data-id="element-109" />
          <FAQItem question="¿Y si ya probé otros libros sin gluten y no funcionaron?" answer="Los libros que probaste antes te dieron recetas sin explicarte el por qué detrás de cada ingrediente y técnica. Con el Método Repostería Zero entiendes el sistema completo. Cuando entiendes el sistema, los resultados son predecibles siempre." data-id="element-110" />
          <FAQItem question="¿Cómo recibo el ebook?" answer="Inmediatamente después de completar tu pago recibirás un email con el link de descarga. Formato PDF de alta calidad optimizado para celular, tablet o computadora. Sin esperas. Sin envíos." data-id="element-111" />
          <FAQItem question="¿Funciona para veganos?" answer="Sí. Cada receta con huevo incluye su versión vegana con huevo de chía o linaza. El libro es completamente adaptable a cualquier nivel de restricción adicional." data-id="element-112" />
        </div>
      </div>
    </section>;
}